import script from "./ClientTags.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientTags.vue?vue&type=script&lang=ts&setup=true"

import "./ClientTags.vue?vue&type=style&index=0&id=09b3a1c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b3a1c4"]])

export default __exports__